import React from 'react';
import { Text, TimeIcon } from '@beef/ui-kit';
import { Flex } from '@fttb/common/components';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var CardText = function CardText(_ref) {
  var date = _ref.date,
    readTime = _ref.readTime,
    text = _ref.text;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    className: cx('text'),
    color: "grey60",
    size: "size5-r-l",
    "data-t-id": "components-CardText"
  }, text), /*#__PURE__*/React.createElement(Flex, {
    className: "mar-t-s",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Flex, {
    "data-t-id": "components-CardText-2"
  }, readTime && /*#__PURE__*/React.createElement(TimeIcon, {
    fill: "#727281",
    size: 20
  }), /*#__PURE__*/React.createElement(Text, {
    color: "grey60",
    size: "size5-r-s"
  }, readTime)), /*#__PURE__*/React.createElement(Text, {
    color: "grey60",
    size: "size5-r-s"
  }, date)));
};